class Type {

	public static AVATAR = new Type("avatar", "Team Member Photo");
	public static LABEL = new Type("label", "Member");
	public static ID = new Type("id", "Member ID");
	public static ROLE = new Type("role", "Role");
	public static CREATED_ON = new Type("createdOn", "Created");
	public static LAST_LOGIN = new Type("lastLogin", "Last Login");
	public static ACTION = new Type("action", "Agent Bio");
	public static BILLABLE_USER = new Type("billableUser", "Billable");
	public static LEADS = new Type("leads", "Leads");
	public static ACTIVE_LISTINGS = new Type("activeListings", "Active Listings");
	public static OFFICE = new Type("office", "Office");
	public static ROUTING = new Type("routing", "Routing");
	// Legacy column types — no longer rendered as their own columns (consolidated into ROUTING),
	// kept for filter groups and back-compat with previously persisted column ids.
	public static GEOGRAPHIC_ROUTING = new Type("geographicRouting", "Geographic Routing");
	public static ROUND_ROBIN = new Type("roundRobin", "Round Robin");


	private constructor(
		public readonly id: string,
		public readonly label: string,
	) {
	}

	public get avatar() {
		return this === Type.AVATAR;
	}

	public get lastLogin() {
		return this === Type.LAST_LOGIN;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: string) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as AgentColumnType };
